import script from "./TopProductsWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./TopProductsWidget.vue?vue&type=script&setup=true&lang=js"

import "./TopProductsWidget.vue?vue&type=style&index=0&id=6ded94ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ded94ae"]])

export default __exports__